import { legacy_createStore } from 'redux'
import UserReducer from './UserReducer'

export const store = legacy_createStore(UserReducer)